import(/* webpackMode: "eager" */ "/app/apps/reporting-maximizer/src/app/error.tsx");
